import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { UserManagementModel } from '../models/userManagementModel/usermang.model';
import { appConfig, AuthGaurdService } from './auth-gaurd.service';
import { catchError, map, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, throwError } from 'rxjs';

import { environment } from '../../environments/environment';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

  private host = environment.apiUrl + "usermanagement";
  public loggedinUser: string = '';
  menuSubMenuData: UserManagementModel[] = [];
  favMenuData: UserManagementModel[] = [];

  private menuListSubject = new BehaviorSubject<UserManagementModel[]>([]);
  menuList$ = this.menuListSubject.asObservable();

  constructor(private http: HttpClient,
    private logger: LoggerService, private authGaurdService: AuthGaurdService) {
    this.loggedinUser = this.authGaurdService.loginUser();
    //console.log('UserManagementService login name ', this.loggedinUser);
  }

  public addRole(formData: FormData): Observable<UserManagementModel> {
    return this.http.post<UserManagementModel>(`${this.host}/roles/addrole`, formData);
  }

  public updateRole(formData: FormData): Observable<UserManagementModel> {
    return this.http.post<UserManagementModel>(`${this.host}/roles/updaterole`, formData);
  }

  public deleteRole(id: number): Observable<CustomHttpRespone> {
    return this.http.delete<CustomHttpRespone>(`${this.host}/roles/deleterole/${id}`);
  }

  public addPage(formData: FormData): Observable<UserManagementModel> {
    return this.http.post<UserManagementModel>(`${this.host}/pagenavigations/addpage`, formData);
  }

  public updatePage(formData: FormData): Observable<UserManagementModel> {
    return this.http.post<UserManagementModel>(`${this.host}/pagenavigations/updatepage`, formData);
  }

  public deletePage(id: number): Observable<CustomHttpRespone> {
    return this.http.delete<CustomHttpRespone>(`${this.host}/pagenavigations/deletepage/${id}`);
  }

  public updateAccessStatusViews(formData: FormData): Observable<UserManagementModel> {
    return this.http.put<UserManagementModel>(`${this.host}/userrolemappings/assignpagetoroleviews`, formData);
  }
  public updateAccessStatusEdits(formData: FormData): Observable<UserManagementModel> {
    return this.http.put<UserManagementModel>(`${this.host}/userrolemappings/assignpagetoroleedits`, formData);
  }

  public getSubMenus(roleid: string, menuid: string) {
    //console.log("roleid = "+roleid);
    //console.log("menuid = "+menuid);
    let url = this.host + '/pagenavigations/getsubmenus/' + roleid + "/" + menuid;
    return this.http.get<any>(url)
      .pipe(
        map((data: any) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public getRoles() {
    let url = this.host + '/roles/getrolelist';
    return this.http.get<UserManagementModel[]>(url)
      .pipe(
        map((data: UserManagementModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

 

  public getAllData(): Observable<UserManagementModel[]> {
    return this.http.get<UserManagementModel[]>(`${this.host}/roles/getalldata`);
  }

  public getPages() {
    let url = this.host + '/pagenavigations/getpages';
    return this.http.get<UserManagementModel[]>(url)
      .pipe(
        map((data: UserManagementModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public getMenus() {
    let url = this.host + '/pagenavigations/getmenus';
    return this.http.get<UserManagementModel[]>(url)
      .pipe(
        map((data: UserManagementModel[]) => {
          return data;

        }), catchError(error => {
          return throwError('Something went wrong!');
        })
      )
  }

  public createMapForm(id: string, pageid: string, status: string, parentpageid: string): FormData {
    const formData = new FormData();
    console.log("parentpageid = "+parentpageid);
    formData.append('id', id);
    formData.append('pageid', pageid);
    formData.append('status', status);
    formData.append('parentpageid', parentpageid);
    formData.append('currentUser', this.authGaurdService.loginUser());
    //console.log("formData: " + formData);
    return formData;
  }

  public createRoleForm(addRole: UserManagementModel): FormData {
    const formData = new FormData();

    console.log(this.loggedinUser);
    formData.append('id', addRole.id);
    formData.append('role_name', addRole.role_name);
    formData.append('role_desc', addRole.role_desc);
    formData.append('email', addRole.email);
    formData.append('comment', addRole.comment);
    formData.append('currentUser', localStorage.getItem('CURRENT_USER_NAME_SESSION'));
    //console.log("formData: " + formData);
    return formData;
  }

  public createPageForm(addPage: UserManagementModel): FormData {
    const formData = new FormData();

    formData.append('id', addPage.page_nav_id);
    formData.append('nav_page_name', addPage.nav_page_name);
    formData.append('nav_page_desc', addPage.nav_page_desc);
    formData.append('comment', addPage.comment);
    formData.append('page_order', addPage.page_order);

    //console.log("addPage.parent_page_id = "+addPage.parent_page_id);

    var parent_page_id: string = "";

    if (addPage.parent_page_id == "" || addPage.parent_page_id == null) {
      parent_page_id = "0";
    } else {
      parent_page_id = addPage.parent_page_id;
    }
    formData.append('parent_page_id', parent_page_id);
    formData.append('currentUser', this.loggedinUser);
    //console.log("formData: " + formData);
    return formData;
  }

  public getMenuListByRole(netWorkId: string) {
    let url = this.host + '/pagenavigations/getmenuList/' + netWorkId;
    return this.http.get<UserManagementModel[]>(url)
    .pipe(
      tap(
        menuData => {
          this.menuListSubject.next(menuData);
        }
      ),
        catchError(error => {
          return throwError('Something went wrong!');
        })
      )
  }

  public getFavMenus(EmpId: string) {
    let url = this.host + '/pagenavigations/getfavmenuList/' + EmpId;
    return this.http.get<UserManagementModel[]>(url)
      .pipe(
        map((data: UserManagementModel[]) => {
          return data;

        }), catchError(error => {
          return throwError('Something went wrong!');
        })
      )
  }

  public handleError(error: { error: { message: string; }; status: any; message: any; }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}


